import { combineReducers } from 'redux'
import WelcomeReducer from './WelcomeReducer'
import SignInReducer from './SignInReducer'
import ChooseLayoutReducer from './ChooseLayoutReducer'
import ChooseUnitReducer from './ChooseUnitReducer'
import ReviewUnitReducer from './ReviewUnitReducer'
import ContactUsReducer from './ContactUsReducer'


export default combineReducers({
    SignInReducer,
    WelcomeReducer,
    ChooseLayoutReducer,
    ChooseUnitReducer,
    ReviewUnitReducer,
    ContactUsReducer
})